<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Add UPI ID</v-toolbar-title>
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>

                <v-flex xs12 sm12 md12 form-item>
	               <v-text-field 
                        v-model="Form.UPIName" 
                        label="UPI Name" 
                        placeholder=" " 
                        v-validate="'required'" 
                        :error-messages="errors.collect('upi_name')" 
                        data-vv-name="upi_name" 
                        data-vv-as="UPI Name" 
                        required>
                    </v-text-field>

	            </v-flex>

				<v-flex xs12 sm12 md12 form-item padding-top-ten>
	               <v-text-field 
	               	:hide-details="!errors.has('upi_id')"
	               	v-model="Form.UpiID" 
	               	label="UPI ID" 
	               	placeholder=" " 
	               	v-validate="'required'" 
	               	:error-messages="errors.collect('upi_id')" 
	               	data-vv-name="upi_id" 
	               	data-vv-as="UPI ID" 
	               	required>
	            </v-text-field>

	               <div class="pt-1" right-align font12 light-opacity-color>Example: 1234567890@abc</div>
	            </v-flex>

	            <!-- <v-flex xs12 sm12 md12 form-item>
	               <v-checkbox v-model="Form.ShowInSalesPrintOuts" label="Show in Sale Invoice"></v-checkbox>
	            </v-flex> -->
								
			</v-layout>

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
		</v-form>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				Form:{"UpiID":null, "UPIName":null}
			}
		},
		methods:{

			fn_checkValidations: function(){
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			        	this.fn_getToken()
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			fn_getToken: function(){
				let self = this;
				this.showLoading("Please wait...");
				this.$root.fn_getAuthToken(function(token){
            		self.fn_saveUpiDetails(token);
				});
			},

			fn_saveUpiDetails: function(token){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }

                let self = this;

                let postObj = {};
                postObj.UpiID = this.Form.UpiID;
                postObj.UPIName = this.Form.UPIName;
                // postObj.ShowInSalesPrintOuts = this.Form.ShowInSalesPrintOuts;
                postObj.BusinessID = this.$root.CurrentBusiness.BusinessID;
                postObj.token = token;

                console.log(JSON.stringify(postObj));

                this.postServerData('PostUpiId', postObj, {
                    onSuccess: function(response){
                       console.log(response);
                       self.$root.CurrentBusiness.UpiID = self.Form.UpiID;
                       self.$root.CurrentBusiness.UPIName = self.Form.UPIName;
                       // self.$root.CurrentBusiness.ShowInSalesPrintOuts = self.Form.ShowInSalesPrintOuts;
                       self.showToast("Upi details saved");
                       self.hideLoading();
                       if(self.$route.query.edit){
                       	self.fn_goBack();
                       }
                       else{
                       	self.$router.replace({"path":"/settings/payment/upi/display"});
                       }
                       
                    }, 
                    onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                    }, 
                })
            },

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		mounted: function(){

			this.Form.UpiID = this.$root.CurrentBusiness.UpiID;
            this.Form.UPIName = this.$root.CurrentBusiness.UPIName;

			// if(this.$root.CurrentBusiness.ShowInSalesPrintOuts != null || this.$root.CurrentBusiness.ShowInSalesPrintOuts != undefined){
			// 	this.Form.ShowInSalesPrintOuts = this.$root.CurrentBusiness.ShowInSalesPrintOuts;
			// }
			

			window.js_globals.fn_onBackPress = this.fn_goBack;

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

		}
	}

</script>


// WEBPACK FOOTER //
// src/components/settings/payment/form_upi.vue